"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const show_json_1 = require("./show-json");
exports.ShowDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('Show', show_json_1.ShowJsonMapper);
